<agr-page-toolbar
  [pageTitle]="pageTitle$ | async"
  [hasPrimaryAction]="false"
  class="individual-fertility"
>
  <div class="wrapper--spacing-all">
    <div class="flex--justify-space-between">
      <app-production-picker
        (productionChanged)="onProductionChanged($event)"
      ></app-production-picker>
    </div>

    <div class="flex__child--auto">
      <div class="table-desktop">
        <table
          mat-table
          matSort
          matSortActive="parity"
          matSortDirection="desc"
          #table
          [dataSource]="dataSource"
          class="table-desktop__table--alternate-rows cust-table"
        >
          @for (column of columnIds(); track column; let colIndex = $index) {
            <ng-container matColumnDef="{{ column }}">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>
                <div>
                  {{ columns[colIndex].label | translate }}
                </div>
              </th>
              <td mat-cell *matCellDef="let row">
                @if (columns[colIndex].type === 'link') {
                  <div>
                    <button mat-button (click)="openCowDetails(row)">
                      {{ row[column] }}
                    </button>
                  </div>
                }
                @if (columns[colIndex].type === 'string') {
                  <div>{{ row[column] }}</div>
                }
                @if (columns[colIndex].type === 'number') {
                  <div>
                    {{ row[column] | number: '1.0-0' }}
                  </div>
                }
                @if (columns[colIndex].type === 'date') {
                  <div>
                    {{ row[column] | date: dateFormat }}
                  </div>
                }
                @if (columns[colIndex].type === 'expected-calving-date') {
                  <div>
                    {{ row[column] | date: dateFormat }}
                    @if (row[column] !== null && row.parity === 0) {
                      <span>*</span>
                    }
                  </div>
                }
                @if (columns[colIndex].type === 'insemination') {
                  <div [class]="{ attention: row[column] > 4 }">
                    {{ row[column] | number: '1.0-0' }}
                  </div>
                }
                @if (columns[colIndex].type === 'pregnancy-status') {
                  <div>
                    {{
                      'fertility.individual-fertility.pregnancy-status-' + row[column] | translate
                    }}
                  </div>
                }
              </td>
            </ng-container>
          }
          <tr mat-header-row *matHeaderRowDef="columnIds()"></tr>
          <tr mat-row *matRowDef="let row; columns: columnIds()"></tr>
        </table>
      </div>
    </div>
    <agr-notification-empty
      [isEmpty]="!hasData"
      [emptyTitle]="'no_items' | translate"
      emptyImage="/assets/images/no-items.png"
      class="complete__notification-empty"
    >
    </agr-notification-empty>
  </div>
</agr-page-toolbar>
